import { FormType, HintItem } from "../../store/slices/app";
import { adminInstance, instance } from "../api";

const getPortalSettings = () => {
  return instance
    .get<{
      status: boolean;
      title: string;
      subtitle: string;
      url: string;
      bccEMailAddress: string;
      hints: {
        [FormType.Sperrmuell]: HintItem[];
        [FormType.Objektverwaltung]: HintItem[];
        [FormType.Reklamation]: HintItem[];
        [FormType.Zusatzleistungen]: HintItem[];
        [FormType.SEPA]: HintItem[];
        [FormType.Eigentuemerwechsel]: HintItem[];
      };
    }>(`/portal-settings`)
    .then((res) => res.data);
};

const getHintsText = () => {
  return adminInstance
    .get<{
      hints: {
        [FormType.Sperrmuell]: HintItem[];
        [FormType.Objektverwaltung]: HintItem[];
        [FormType.Reklamation]: HintItem[];
        [FormType.Zusatzleistungen]: HintItem[];
        [FormType.SEPA]: HintItem[];
        [FormType.Eigentuemerwechsel]: HintItem[];
      };
    }>("/admin/hints")
    .then((res) => res.data);
};
// const updateHintsText = (data: { step: number; hints: string[] }[]) => {
const updateHintsText = (data: Record<string, HintItem[]>) => {
  return adminInstance
    .post<{
      hints: {
        [FormType.Sperrmuell]: HintItem[];
        [FormType.Objektverwaltung]: HintItem[];
        [FormType.Reklamation]: HintItem[];
        [FormType.Zusatzleistungen]: HintItem[];
        [FormType.SEPA]: HintItem[];
        [FormType.Eigentuemerwechsel]: HintItem[];
      };
    }>("/admin/hints", data)
    .then((res) => res.data);
};

const Portal = {
  get: {
    getPortalSettings,
    getHintsText,
  },
  post: {
    updateHintsText,
  },
};

export default Portal;
